export interface StockStatus {
  quantity: number;
  date: string; // 'dd/MM/yyyy'
  hour: string; // 'HH:mm'
}

class StockStatusData {
  stockStatus: StockStatus[];

  constructor(stockStatus: StockStatus[]) {
    this.stockStatus = stockStatus;
  }
}

export default StockStatusData;
